import getConfig from 'next/config';

import {getCategoryBy} from '~/src/utilities/feed/sitemap';
import {getCategoryUrl, getVideoUrl, getContentUrl} from '~/src/utilities/helpers/link';
import {getLifestyleFront} from '~/src/utilities/helpers/lifestyle';
import {getVideoFront} from '~/src/utilities/helpers/video';
import {ContentType} from '~/src/utilities/constants/types';
import {stripHTML} from '~/src/utilities/helpers/string';

const {publicRuntimeConfig: config} = getConfig();

const getCategoriesInTree = (categoryId, categories) => {
    const result = [];

    let category = getCategoryBy(categories, {categoryId});
    if (category) {
        result.unshift(category);

        while ((category = getCategoryBy(categories, {categoryId: category.parent}))) {
            result.unshift(category);
        }
    }

    // finally, add front category (if not already done)
    category = getCategoryBy(categories, {fullUrlPath: config.frontCategory});
    if (category.categoryId !== categoryId) {
        result.unshift(category);
    }

    return result;
};

const createBreadcrumbItem = (fullUrlPath, title, position) => ({
    '@type': 'ListItem',
    position,
    item: {
        '@id': `${config.canonicalBaseUrl}${fullUrlPath}`,
        name: stripHTML(title)
    }
});

const selectCategoryUrl = ({fullUrlPath}, categories) => {
    switch (fullUrlPath) {
        case 'video':
            return getCategoryUrl(getVideoFront(categories).fullUrlPath);
        case 'lifestyle':
            return getCategoryUrl(getLifestyleFront(categories).fullUrlPath);
        default:
            return getCategoryUrl(fullUrlPath);
    }
};

/**
 *
 * @param {number} categoryId Feed ID for the current category
 * @param {string} categoryName Name of the current category
 * @param {object[]} categories Array of all the categories
 */
const getStructuredCategoryBreadcrumbs = (categoryId, categories) => ({
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: getCategoriesInTree(categoryId, categories).map((category, index) =>
        createBreadcrumbItem(selectCategoryUrl(category, categories), category.name, index + 1)
    )
});

/**
 *
 * @param {object} params Object containing url, type, name and main category as props
 * @param {object[]} categories Array of all the categories
 */
const getStructuredContentBreadcrumbs = ({url, type, name, mainCategory}, categories) => {
    const category = getCategoryBy(categories, {categoryId: mainCategory}) || getCategoryBy(categories, {fullUrlPath: config.frontCategory});
    const data = getStructuredCategoryBreadcrumbs(category.categoryId, categories);
    const contentUrl = type === ContentType.VIDEO ? getVideoUrl(url) : getContentUrl(url);

    data.itemListElement.push(createBreadcrumbItem(contentUrl, name, data.itemListElement.length + 1));

    return data;
};

export {getStructuredCategoryBreadcrumbs, getStructuredContentBreadcrumbs};
